<!--  -->
<template>
  <div>
    <div class="search-row">
      <div class="search-item">
        <span class="mr5">公告内容</span>
        <el-input size="mini" clearable class="input200" v-model="queryParams.content" :placeholder="`请输入`"></el-input>
      </div>
      <div class="search-item">
        <span class="mr5">时间范围</span>
        <el-date-picker size="mini" clearable v-model="queryParams.time" type="datetimerange" :range-separator="`至`" :start-placeholder="`开始日期`" :end-placeholder="`结束日期`" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
      </div>
      <div class="search-item">
        <span class="mr5">状态</span>
        <el-select v-model="queryParams.status" size="mini" clearable :placeholder="`请选择`">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </div>
      <div>
        <el-button size="mini" type="primary" @click="search">搜索</el-button>
        <el-button size="mini" type="primary" @click="openDialog(`新增`, false)">新增</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table class="mt10" ref="multipleTable" border :data="list">
      <el-table-column type="index" label="#" width="55"></el-table-column>
      <el-table-column v-for="item in columns" :label="item.text" :key="item.column" :width="item.width">
        <template slot-scope="scope">
          <!-- 操作 -->
          <template v-if="item.column == 'handle'">
            <!-- 编辑：未发布、发布中、发布停止可用 -->
            <el-button :disabled="scope.row.status == 2" type="text" @click="openDialog(`修改公告`, true, scope.row)">编辑</el-button>
            <!-- 发布：未发布、发布停止可用。发布完成、发布中不可用 -->
            <el-button :disabled="scope.row.status == 2 || scope.row.status == 1" type="text" @click="removeData(scope.row, `确定发布通知吗？`, `发布成功！`)">发布</el-button>
            <!-- 下架：发布中可用。未发布、发布停止、发布完成不可用。 -->
            <el-button :disabled="scope.row.status != 1" type="text" @click="removeData(scope.row, `确定下架通知吗？`, `下架成功！`)">下架</el-button>
            <!-- 刪除：当前时间到了“发布开始时间”，就不能删除 -->
            <el-button :disabled="!(scope.row.status == 0 || (scope.row.status == 1 && !beforeOrAfter(scope.row.start_time)))" type="text" @click="deleteData(scope.row)">删除</el-button>
          </template>
          <span :title="scope.row[item.column]" class="inputClass" v-else-if="item.column == 'content'">{{ scope.row[item.column] }}</span>
          <span v-else>{{ scope.row[item.column] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination :queryParams="queryParams" :getList="getList" />

    <!-- 新增和修改的弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="800px" @close="onClose">
      <el-form ref="form" :rules="rules" :model="form" label-width="180px">
        <el-form-item :label="`公告内容`" prop="content">
          <el-input maxlength="50" class="width-400" v-model="form.content"></el-input>
        </el-form-item>
        <el-form-item :label="`公告发布时间范围`" prop="time">
          <el-date-picker clearable v-model="form.time" type="datetimerange" 
          :range-separator="`至`" :start-placeholder="`开始日期`" :end-placeholder="`结束日期`"
          :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions"> </el-date-picker>
        </el-form-item>
        <el-form-item :label="`类型`">
          <el-select v-model="form.type">
            <el-option
              v-for="item in typeOption"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="!isEdit" :label="`是否发布`">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="row-center">
        <el-button @click="closeFun">取消</el-button>
        <el-button class="ml20" type="primary" @click="confirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination';
import { notice, noticeSave, noticeChange, noticeDelete } from '@/api.js';
import { pageSize } from '@/utils/Config';
export default {
  components: {
    Pagination,
  },
  data() {
    var checkTime = (rule, value, callback) => {
      // 校验选择的时间是否早于当前时间
      if (value && value.length == 2 && this.beforeOrAfter(value[0])) {
        callback(new Error(`开始时间不得早于当前时间`));
      } else {
        callback();
      }
    };
    return {
      isEdit: false,
      rules: {
        content: [{ required: true, message: `请输入公告内容`, trigger: 'blur' }],
        time: [
          { required: true, message: `请选择时间`, trigger: 'change' },
          { validator: checkTime, trigger: 'blur' },
        ],
      },
      dialogVisible: false,
      dialogTitle: `新建公告`,
      options: [
        {
          value: 0,
          label: `未发布`,
        },
        {
          value: 1,
          label: `发布中`,
        },
        {
          value: 3,
          label: `发布停止`,
        },
        {
          value: 2,
          label: `发布完成`,
        },
      ],
      typeOption:[
        {
          value: 0,
          label: `通用`
        },        {
          value: 1,
          label: `发版维护`
        },
      ],
      list: [],
      columns: [],
      queryParams: {
        pageIndex: 1,
        pageSize: pageSize,
        _total: 0,
      },
      form: {
        content: '',
        time: [],
        status: 1,
        type:0,
      },
      // 时间的限制
      pickerOptions: {
        disabledDate(v) {
          return v.getTime() < new Date().getTime() - 86400000; // 是否包括当天
        },
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取列表数据
    getList() {
      const { pageIndex, pageSize, status, content, time } = this.queryParams;
      const query = {
        page: pageIndex,
        per_page: pageSize,
        status,
        content,
        start_time: time ? time[0] : undefined,
        end_time: time ? time[1] : undefined,
      };
      if (query.status === '') {
        delete query.status;
      }
      this.$request('get', notice, query).then((res) => {
        if (res) {
          this.list = res.data;
          this.columns = res.columns;
          this.queryParams._total = res.total;
        }
      });
    },

    // 搜索
    search() {
      this.queryParams.pageIndex = 1;
      this.getList();
    },

    // 关闭按钮：
    closeFun() {
      this.dialogVisible = false;
    },

    // 当弹框关闭时：
    onClose() {
      this.form = {
        content: '',
        time: [],
        status: 1,
        type:0,
      };
      this.$refs.form.resetFields();
    },

    // 弹框里的确认
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let { content, time, status,type } = this.form;
          let query = {
            content,
            start_time: time ? time[0] : '',
            end_time: time ? time[1] : '',
            status,
            type,
          };
          if (this.isEdit) {
            query.id = this.id;
          }
          this.$request('post', noticeSave, query).then((res) => {
            if (res) {
              this.dialogVisible = false;
              this.search();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 新增
    openDialog(title, isEdit, data) {
      if (isEdit) {
        // 是编辑时：
        this.id = data.id;
        this.form = {
          content: data.content,
          time: [data.start_time, data.end_time],
          status: data.status,
          type:data.type,
        };
      }
      this.dialogVisible = true;
      this.dialogTitle = title;
      this.isEdit = isEdit;
    },

    // 下架：
    removeData(data, contentText, successText) {
      this.$confirm(contentText, `提示`, {
        confirmButtonText: `确定`,
        cancelButtonText: `取消`,
        type: 'warning',
      }).then(() => {
        this.$request('post', noticeChange, {
          id: data.id,
        }).then((res) => {
          if (res) {
            this.getList();
            this.$message({
              type: 'success',
              message: successText,
            });
          }
        });
      });
    },

    // 删除：
    deleteData(data) {
      this.$confirm(`是否确认删除`, `提示`, {
        confirmButtonText: `确定`,
        cancelButtonText: `取消`,
        type: 'warning',
      }).then(() => {
        this.$request('post', noticeDelete, {
          id: data.id,
        }).then((res) => {
          if (res) {
            this.getList();
            this.$message({
              type: 'success',
              message: `删除成功`,
            });
          }
        });
      });
    },

    // 判断给定时间是否是在当前时间之后
    beforeOrAfter(data) {
      const currentTime = new Date();
      const compareTime = new Date(data);
      if (compareTime.getTime() < currentTime.getTime()) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.search-row {
  display: flex;
}
.search-item {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.inputClass {
  white-space: nowrap; /* 强制单行显示 */
  text-overflow: ellipsis; /* 超出部分省略号表示 */
  overflow: hidden; /* 超出部分隐藏 */
  width: 154px; /* 设置显示的最大宽度 */
  display: inline-block; /* 转变为行内块体元素，以便设置宽度和高度 */
}
.row-center {
  text-align: center;
}
.width-400 {
  width: 400px;
}
</style>
